const color = {
    primary: "#FF5370",
    darkPrimary: "#187dc1",
    secondary: "#3AB77B",
    darkSecondary: "#32A66E",
    warning: "#3B5AA1",
    success: "#3AB77B",
    error: "#E9645B",
    errorBackground: "#FFF2F1",
    white: "#fff",
    lightDark1: "#DADADA",
    lightDark2: "#949494",
    lightDark3: "#D6D6D6",
    confirm: "#D27062",
    darkConfirm: "#ce5342",
    disabledBackground: "#f3f3f3",
    yellow: "#E9C25F",
    GREY_COLOR_2: "#A4A4A4",
    textPrimary: "#333",
    grey50:"#F5F5F5",
    grey100: "#EEEEEE",
    grey200: "rgba(0, 0, 0, 0.23)",
    grey300:"#A2A8B4",
    hightlight: "#DBB24A",
    background : "#152036"
  };
  
  export default color;
  